import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { BeneficiarioStatus } from 'src/app/core/models/onboarding/BeneficiarioStatus';
import { OnboardingService } from 'src/app/core/services/onboarding';

@Component({
  selector: 'app-onboarding-beneficiarios',
  templateUrl: './onboarding-beneficiarios.component.html',
  styleUrls: ['./onboarding-beneficiarios.component.scss'],
})
export class OnboardingBeneficiariosComponent implements OnInit {
  @Output() finalize = new EventEmitter();

  onboardingService = inject(OnboardingService);

  beneficiarioStatus?: BeneficiarioStatus;

  ngOnInit(): void {
    this.loadOnboardingStatus();
  }

  onFinalize(): void {
    this.finalize.emit();
  }

  private loadOnboardingStatus(): void {
    this.onboardingService
      .getBeneficiarioStatus()
      .subscribe((beneficiarioStatus) => {
        this.beneficiarioStatus = beneficiarioStatus;
      });
  }
}
